import { Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'timesheet-grand-total',
  templateUrl: './timesheet-grand-total.component.html',
})
export class TimesheetGrandTotalComponent {
  @Input()
  time: number;
  @Input()
  salary: number;
  @Input()
  showSalary: boolean;
  @Input()
  showAsFooter: boolean;
  @Input()
  coc: number;
  @Input()
  showCoc = false;

  @HostBinding('style.height.px')
  height = 36;
}
